/* eslint-disable */
export enum FinnairItineraryItemFlightStatus {
  CONFIRMED = 'CONFIRMED',
  WAITLISTED = 'WAITLISTED',
  CANCELED = 'CANCELED',
  FLOWN = 'FLOWN',
  CHECKED_IN = 'CHECKED_IN'
}

